import SearchIcon from '@mui/icons-material/Search';
import { FormControl, FormHelperText, Grid, MenuItem, Select, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { sanitizeInput } from 'utils/helpers/sanitizeInput/sanitizeInput';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';

export const SearchOrdersForm = ({
  handleSubmit,
  onSubmit,
  register,
  control,
  taxDataValidations,
  errors,
  setValue,
}) => {
  return (
    <Grid
      container
      spacing={2}
      alignItems={'flex-start'}
      size={{ xs: 12, md: 6 }}
      component='form'
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid size={{ xs: 12, md: 4 }}>
        <FormControl fullWidth>
          <Controller
            name='carrier_id'
            control={control}
            rules={taxDataValidations.carrier_id}
            render={({ field }) => (
              <Select
                fullWidth
                {...field}
                value={field.value ?? ''}
                error={Boolean(errors.carrier_id)}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              >
                <MenuItem value={1}>Dalefon</MenuItem>
                <MenuItem value={2}>IPB</MenuItem>
              </Select>
            )}
          />
          <FormHelperText sx={{ minHeight: 24, color: '#D32F2F' }}>
            {errors.carrier_id?.message || ' '}
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          fullWidth
          placeholder='Ingresa el RFC'
          {...register('legal_id', taxDataValidations.rfc)}
          error={Boolean(errors.legal_id)}
          helperText={errors.legal_id?.message || ' '}
          FormHelperTextProps={{ sx: { minHeight: 24 } }}
          onChange={(event) => {
            const cleaned = sanitizeInput(event.target.value, 'rfc');
            setValue('legal_id', cleaned, { shouldDirty: true });
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <GenericAddButton
          buttonText='Buscar'
          backgroundColor='#6c39d2'
          size='medium'
          isSubmit
          icon={<SearchIcon />}
        />
      </Grid>
    </Grid>
  );
};
